package org.zest.insan_360_website.pages.user

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.rememberCoroutineScope
import com.varabyte.kobweb.compose.css.PointerEvents
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.ui.styleModifier
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.PageContext
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.silk.style.CssStyle
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.ExperimentalComposeWebApi
import org.jetbrains.compose.web.css.*
import org.zest.insan_360_website.components.widgets.LocalModal
import org.zest.insan_360_website.components.widgets.LocalToast
import org.zest.insan_360_website.components.widgets.VideoModal
import org.zest.insan_360_website.data.LanguageSettings
import org.zest.insan_360_website.data.page_states.AuthState
import org.zest.insan_360_website.data.page_states.CreditState.fetchActiveCreditSession
import org.zest.insan_360_website.data.page_states.CreditState.fetchCurrentCreditStatus
import org.zest.insan_360_website.data.page_states.MaintenanceState.fetchMaintenanceStatus
import org.zest.insan_360_website.data.page_states.UserPreferences
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.consumeCreditAndProceed
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.fetchAdminDashboardInfo
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.fetchPersonalCreditHistory
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.fetchSupAdmDashboardInfo
import org.zest.insan_360_website.data.page_states.dashboard.MainDashPageState.showVideoModal
import org.zest.insan_360_website.model.UserRole
import org.zest.insan_360_website.pages.user.main_layout.AdminLayout
import org.zest.insan_360_website.pages.user.main_layout.StudentLayout
import org.zest.insan_360_website.pages.user.main_layout.SuperAdminLayout

@OptIn(ExperimentalComposeWebApi::class)
val contentBackgroundIconStyle = CssStyle {
    base {
        Modifier
            .position(Position.Absolute)
            .opacity(0)
            .transform {
                translate(tx = (-120).percent, ty = (-100).percent)
            }
            .pointerEvents(PointerEvents.None)
            .zIndex(0)
            .styleModifier {
                transitions {
                    "opacity" { duration(0.45.s) }
                    "transform" { duration(0.45.s) }
                }
            }
    }
}

@Page("index")
@Layout(".components.layouts.UserDashboardLayout")
@Composable
fun UserMainPage(ctx: PageContext) {
    val scope = rememberCoroutineScope()
    val toast = LocalToast.current

    LaunchedEffect(Unit) {
        if (AuthState.role == UserRole.STUDENT) {
            fetchCurrentCreditStatus()
            fetchActiveCreditSession()
            fetchPersonalCreditHistory()
        }
        if (AuthState.role == UserRole.ADMIN) fetchAdminDashboardInfo(scope)
        if (AuthState.role == UserRole.SUPER_ADMIN) {
            fetchMaintenanceStatus(scope)
            fetchSupAdmDashboardInfo(scope)
        }
    }

    val modal = LocalModal.current
    LaunchedEffect(showVideoModal) {
        if (showVideoModal) {
            modal.show(closeableOutside = false) {
                VideoModal(
                    videoUrls = listOf("https://vz-65b7a693-e53.b-cdn.net/fc6633cd-4481-45d8-bbd1-328575d21d61/play_720p.mp4"),
                    title = LanguageSettings.UserDashboardPage.VideoModal.title[UserPreferences.language] ?: "Please watch the briefing before proceeding",
                    finishButtonText = LanguageSettings.UserDashboardPage.VideoModal.finish_video[UserPreferences.language] ?: "Finish the video to proceed",
                    proceedButtonText = LanguageSettings.UserDashboardPage.VideoModal.start_test[UserPreferences.language] ?: "Start Assessment",
                    onProceed = {
                        modal.hide(fromBackButton = true)
                        showVideoModal = false
                        scope.launch {
                            consumeCreditAndProceed(toast, ctx)
                        }
                    },
                    onCancel = {
                        modal.hide()
                        showVideoModal = false
                    }
                )
            }
        }
    }
    if (AuthState.role == UserRole.STUDENT) StudentLayout(ctx)
    if (AuthState.role == UserRole.ADMIN) AdminLayout()
    if (AuthState.role == UserRole.SUPER_ADMIN) SuperAdminLayout()
}